import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss';
import Input from '/chat/src/components/Forms/Input';
//import ConversationClass from '/chat/src/lib/Conversation';
import {TicketModel, SystemModel, CustomizationModel, ConfigModel, UserModel} from '/chat/src/redux/model'
import {Validation} from '/chat/src/lib'

class StartChattingButton extends Component {
    constructor(props) {
        super(props);
        this.handleNewConversationClick = this.handleNewConversationClick.bind(this);
    }

    handleNewConversationClick(){
        if(this.props.conversations.isEmpty()){
            this.props.dispatch(SystemModel.setRoute('Chat'));
        }else{
            this.props.dispatch(SystemModel.setRoute('Conversations'));
        }
    }

    render(){
        //20px for Powered by Jibber label
        const bodyHeight = this.props.height - 35;
        const bodyHeightPx = bodyHeight + 'px'
        const bodyWidth = this.props.width;
        const language = this.props.language;

        let text = language.get("ContinueChatting");
        if(this.props.conversations.isEmpty())
            text = language.get("StartChatting");


        var size = bodyHeight > bodyWidth ? bodyWidth/2: bodyHeight/2 ;
        size += 30
        let height = size;
        let width = size;
        var borderRadius = size;
        let heightPx = height + 'px';
        let widthPx = width + 'px';
        let marginTop = bodyHeight/2 - size/2 - 10 + 'px';
        let marginBottom = '10px'
        let fontSize = '20px'
        let hoverStyle = " hvr-grow"
        if(bodyHeight < 260){
            heightPx = '55px'
            widthPx = '50%'
            borderRadius = '60px'
            marginTop = height/2 + 'px';
            hoverStyle = " "
        }
        return (
            <div
                className={style.StartChattingButtonWrapper}
                style={{height: bodyHeightPx}}
            >
                <div
                    className={style.StartChattingButton + hoverStyle}
                    onClick={this.handleNewConversationClick}
                    style={{
                        marginTop: marginTop,
                        backgroundColor: this.props.color,
                        width: widthPx,
                        height: heightPx,
                        lineHeight: heightPx,
                        borderRadius: borderRadius,
                        fontSize: fontSize
                    }}>
                    <span className={style.StartChattingText}> {text} </span>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state){
    const color = CustomizationModel.getColor(state)
    const language = CustomizationModel.getLanguage(state)
    const conversations = TicketModel.getAll(state)
    return {
        height: SystemModel.getBodyHeight(state),
        width: SystemModel.getShellWidth(state),
        user: UserModel.get(state).toJS(),
        conversations, color, language
    };
}

export default connect(mapStateToProps)(StartChattingButton);



// WEBPACK FOOTER //
// ./routes/StartChatting/Button.js